import sha256 from 'crypto-js/sha256';

const urlObfuscateToken = '_||_';
function serialize(json) {
    return JSON.stringify(json, (key, value) => {
        if (typeof value === 'string') {
            return value.split('/').join(urlObfuscateToken);
        }

        return value;
    });
}

function deserialize(json) {
    if (typeof json !== 'string') {
        json = JSON.stringify(json);
    }

    return JSON.parse(json, (key, value) => {
        if (typeof value === 'string') {
            return value.split(urlObfuscateToken).join('/');
        }

        return value;
    });
}

/**
 * @return {String} a collision-resistant string suitable for use as an HTML #id
 */
function generateIsomorphicID(props = {}) {
    return sha256(JSON.stringify(props)).toString();
}

export {
    deserialize,
    generateIsomorphicID,
    serialize,
};
